import config from '../../config/config'
import axios from 'axios'
import { getToken } from '../../common'; 

export const sellerUpdateStatusAPI = async (params,sellerId) => {

    return await axios({
        method  : 'put',
        url     : `${config.api.base_url}dashboard/sellers/${sellerId}`,
        data    : params,
        headers : {
            "Content-type": "application/json; charset=UTF-8",
            "Authorization": getToken(),
        }
    })
}

export default sellerUpdateStatusAPI